import { z } from "zod";

export const StudentLifecycleStatus = {
	ACTIVE: "active",
	INACTIVE: "inactive",
	ALUMNI: "alumni",
	WITHDRAWN: "withdrawn",
} as const;

export type StudentLifecycleStatus = (typeof StudentLifecycleStatus)[keyof typeof StudentLifecycleStatus];

export const STUDENT_LIFECYCLE_STATUSES = Object.values(StudentLifecycleStatus) as readonly StudentLifecycleStatus[];

export const studentLifecycleStatusSchema = z.enum(StudentLifecycleStatus);
